
import Vue from 'vue'
import Tools from '@/tools/tools.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      centroEstoqueId: null,
      produtoId: null,
      grupoProdutoId: null,
      exibirZerados: false,
      registroSelecionadoId: null,
      paginaAtual: 1
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    CENTRO_ESTOQUE_ID: state => {
        return state.centroEstoqueId
    },
    PRODUTO_ID: state => {
        return state.produtoId
    },
    GRUPO_PRODUTO_ID: state => {
        return state.grupoProdutoId
    },
    EXIBIR_ZERADOS: state => {
        return state.exibirZerados
    },
    REGISTRO_SELECIONADO_ID: state => {
        return state.registroSelecionadoId
    },
    PAGINA_ATUAL: state => {
        return state.paginaAtual
    }
  },
  mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_CENTRO_ESTOQUE_ID: (state, payload) => {
          state.centroEstoqueId = payload
      },
      SET_PRODUTO_ID: (state, payload) => {
          state.produtoId = payload
      },
      SET_GRUPO_PRODUTO_ID: (state, payload) => {
          state.grupoProdutoId = payload
      },
      SET_EXIBIR_ZERADOS: (state, payload) => {
          state.exibirZerados = payload
      },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
          state.registroSelecionadoId = payload
      },
      SET_PAGINA_ATUAL: (state, payload) => {
          state.paginaAtual = payload
      }
  },
  actions: {
      pesquisar: async ({commit, state, rootState}) => {
        try {
            commit('controle/setAguardando', true, { root: true })
            
            let produtoId = state.produtoId !== null ? `&produtoId=${state.produtoId}` : ''
            let grupoProdutoId = state.grupoProdutoId !== null ? `&grupoProdutoId=${state.grupoProdutoId}` : ''
            let usuarioId = `&usuarioId=${window.localStorage.getItem('usuarioId')}`
            let exibirZerados = `&exibirZerados=${state.exibirZerados}`
            let centroEstoqueId = state.centroEstoqueId !== null ? `centroEstoqueId=${state.centroEstoqueId}` : `centroEstoqueId=`

            const {data} = await Vue.axios.get(`/api/protected/estoque/pesquisarSintetico?${centroEstoqueId}` + produtoId + grupoProdutoId + usuarioId + exibirZerados)
            
            // Map the data to match the component's expected structure
            // The VIEW structure changed, so we need to map new field names to old ones
            // to maintain compatibility with the frontend
            
            let listaMapeada = data.map(est => ({
                PRODUTO_ID: est.ID_PRODUTO,
                CENTRO_ESTOQUE_ID: est.ID_CENTRO_ESTOQUE,
                DESCRICAO: est.DESCRICAO_PRODUTO,
                DESCRICAO_CENTRO_ESTOQUE: est.DESCRICAO_CENTRO_ESTOQUE,
                UND_ENT: est.ID_UNIDADE_COMERCIAL,
                PECAS: est.PECAS,
                QUANT: est.QUANT,
                MEDIA_ESTOQUE: est.MEDIA_ESTOQUE || 0,
                OP_PESO_FIXO: est.OP_PESO_FIXO || '0',
                PESO_LIQUIDO: est.PESO_LIQUIDO || 0,
                PECAS_RESERVADO: est.PECAS_RESERVADO || 0,
                PECAS_DISPONIVEIS: est.PECAS_DISPONIVEIS || 0,
                QUANT_RESERVADA_PRODUCAO: est.QUANT_RESERVADA_PRODUCAO || 0,
                PECAS_RESERVADA_PRODUCAO: est.PECAS_RESERVADA_PRODUCAO || 0,
                VL_CUSTO: est.PRECOCUSTO,
                VL_VENDA: est.VL_VENDA,
                VALIDADE: est.DT_VALIDADE,
                PRECOATACADO: est.PRECOATACADO,
                PRECOVAREJO: est.PRECOVAREJO,
                ID_GRUPO: est.ID_GRUPO,
                DESCRICAO_GRUPO: est.DESCRICAO_GRUPO,
                ID_SUBGRUPO: est.ID_SUBGRUPO,
                DESCRICAO_SUBGRUPO: est.DESCRICAO_SUBGRUPO,
                ESTIMADO: est.ESTIMADO,
                OP_PRODUTO_PRODUCAO: est.OP_PRODUTO_PRODUCAO,
                OP_ALMOXARIFADO: est.OP_ALMOXARIFADO,
                OP_PERMITE_VENDA: est.OP_PERMITE_VENDA,
                OP_BENEFICIA: est.OP_BENEFICIA,
                OP_BENEFICIADO: est.OP_BENEFICIADO,
                // DIAS_SEM_VENDA não está disponível na nova VIEW
                DIAS_SEM_VENDA: null
            }))

            commit('SET_LISTA', listaMapeada)
            
        } catch (error) {
            Tools.exibirMensagem(rootState, 'Aviso', 'warning', error)
        } finally {
            commit('controle/setAguardando', false, { root: true })
        }
      }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/estoque-diversos-store.js